import { createSlice } from '@reduxjs/toolkit';
import { isNumberValid } from 'functions';

export const accountControlSlice = createSlice({
	name: 'accountControl',
	initialState: {
		totalRequests: 0
	},
	reducers: {
		// Get COM List
		getComList_request: (state) => {
			state.getComList_requesting = true;
			state.getComList_isSuccessful = undefined;
			state.comList = undefined;
            state.comListHeaders = undefined;
		},
        getComList_success: (state, action) => {
			state.getComList_requesting = false;
			state.getComList_isSuccessful = true;
            
            state.comList = action?.payload?.data;
            state.comListHeaders = action?.payload?.headers;
		},
        getComList_failure: (state) => {
			state.getComList_requesting = false;
			state.getComList_isSuccessful = false;
		},

		// Get All COM List
		getAllComList_request: (state) => {
			state.getAllComList_requesting = true;
			state.getAllComList_isSuccessful = undefined;
		},
		getAllComList_success: (state, action) => {
			state.getAllComList_requesting = false;
			state.getAllComList_isSuccessful = true;
			
			state.allComList = action.payload;
		},
		getAllComList_failure: (state) => {
			state.getAllComList_requesting = false;
			state.getAllComList_isSuccessful = false;
		},

		// Update Expiry Date
		updateExpiryDate_request: (state) => {
			state.updateExpiryDate_requesting = true;
			state.updateExpiryDate_isSuccessful = undefined;
			state.isUpdateSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		updateExpiryDate_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.updateExpiryDate_requesting = !isDoneRequesting;
			state.updateExpiryDate_isSuccessful = isDoneRequesting;
			state.isUpdateSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		updateExpiryDate_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.updateExpiryDate_requesting = !isDoneRequesting;
			state.updateExpiryDate_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Update Payment Due Date
		updatePaymentDueDate_request: (state) => {
			state.updatePaymentDueDate_requesting = true;
			state.updatePaymentDueDate_isSuccessful = undefined;
			state.isUpdateSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		updatePaymentDueDate_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.updatePaymentDueDate_requesting = !isDoneRequesting;
			state.updatePaymentDueDate_isSuccessful = isDoneRequesting;
			state.isUpdateSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		updatePaymentDueDate_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.updatePaymentDueDate_requesting = !isDoneRequesting;
			state.updatePaymentDueDate_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Reset Payment Due Date
		resetPaymentDueDate_request: (state) => {
			state.resetPaymentDueDate_requesting = true;
			state.resetPaymentDueDate_isSuccessful = undefined;
			state.isUpdateSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		resetPaymentDueDate_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.resetPaymentDueDate_requesting = !isDoneRequesting;
			state.resetPaymentDueDate_isSuccessful = isDoneRequesting;
			state.isUpdateSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		resetPaymentDueDate_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.resetPaymentDueDate_requesting = !isDoneRequesting;
			state.resetPaymentDueDate_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Suspend Request
		suspendCOM_request: (state) => {
			state.suspendCOM_requesting = true;
			state.isUpdateSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		suspendCOM_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.suspendCOM_requesting = !isDoneRequesting;
			state.isUpdateSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		suspendCOM_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.suspendCOM_requesting = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Delete COM
		deleteCOM_request: (state) => {
			state.deleteCOM_requesting = true;
			state.isDeleteCOMSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		deleteCOM_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.deleteCOM_requesting = !isDoneRequesting;
			state.isDeleteCOMSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		deleteCOM_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.deleteCOM_requesting = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Revert Deleted COM
		revertDeletedCOM_request: (state) => {
			state.revertDeletedCOM_requesting = true;
			state.isRevertDeletedCOMSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		revertDeletedCOM_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.revertDeletedCOM_requesting = !isDoneRequesting;
			state.isRevertDeletedCOMSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		revertDeletedCOM_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.revertDeletedCOM_requesting = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Activate Request
		activateCOM_request: (state) => {
			state.activateCOM_requesting = true;
			state.isUpdateSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		activateCOM_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.activateCOM_requesting = !isDoneRequesting;
			state.isUpdateSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		activateCOM_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.activateCOM_requesting = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		
		// Update Trial Status
		updateTrialStatus_request: (state) => {
			state.updateTrialStatus_requesting = true;
			state.isUpdateSuccessful = undefined;

			state.totalRequests = state.totalRequests + 1;
		},
		updateTrialStatus_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.updateTrialStatus_requesting = !isDoneRequesting;
			state.isUpdateSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		updateTrialStatus_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.updateTrialStatus_requesting = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Update Dealer Code
		updateDealerCode_request: (state) => {
			state.updateDealerCode_requesting = true;
			state.updateDealerCode_isSuccessful = undefined;
			state.isUpdateSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		updateDealerCode_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.updateDealerCode_requesting = !isDoneRequesting;
			state.updateDealerCode_isSuccessful = isDoneRequesting;
			state.isUpdateSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		updateDealerCode_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.updateDealerCode_requesting = !isDoneRequesting;
			state.updateDealerCode_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Update Billing Tag
		updateBillingTag_request: (state) => {
			state.updateBillingTag_requesting = true;
			state.updateBillingTag_isSuccessful = undefined;
			state.isUpdateSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		updateBillingTag_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.updateBillingTag_requesting = !isDoneRequesting;
			state.updateBillingTag_isSuccessful = isDoneRequesting;
			state.isUpdateSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		updateBillingTag_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.updateBillingTag_requesting = !isDoneRequesting;
			state.updateBillingTag_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Get Package
		getPackages_request: (state) => {
			state.getPackages_requesting = true;
			state.getPackages_isSuccessful = undefined;
		},
		getPackages_success: (state, action) => {
			state.getPackages_requesting = false;
			state.getPackages_isSuccessful = true;

			state.packageList = action.payload.data;
		},
		getPackages_failure: (state) => {
			state.getPackages_requesting = false;
			state.getPackages_isSuccessful = false;
		},
		
		// Update Package
		updatePackage_request: (state) => {
			state.updatePackage_requesting = true;
			state.updatePackage_isSuccessful = undefined;
			state.isUpdateSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		updatePackage_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.updatePackage_requesting = !isDoneRequesting;
			state.updatePackage_isSuccessful = isDoneRequesting;
			state.isUpdateSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		updatePackage_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.updatePackage_requesting = !isDoneRequesting;
			state.updatePackage_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Set Suspend Date
		setSuspendDate_request: (state) => {
			state.setSuspendDate_requesting = true;
			state.setSuspendDate_isSuccessful = undefined;
			state.isUpdateSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		setSuspendDate_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.setSuspendDate_requesting = !isDoneRequesting;
			state.setSuspendDate_isSuccessful = isDoneRequesting;
			state.isUpdateSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		setSuspendDate_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.setSuspendDate_requesting = !isDoneRequesting;
			state.setSuspendDate_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Remove Suspend Date
		removeSuspendDate_request: (state) => {
			state.removeSuspendDate_requesting = true;
			state.removeSuspendDate_isSuccessful = undefined;
			state.isUpdateSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		removeSuspendDate_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.removeSuspendDate_requesting = !isDoneRequesting;
			state.removeSuspendDate_isSuccessful = isDoneRequesting;
			state.isUpdateSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		removeSuspendDate_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.removeSuspendDate_requesting = !isDoneRequesting;
			state.removeSuspendDate_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
	},
});

export const {
	getComList_request, getComList_success, getComList_failure,
	getAllComList_request, getAllComList_success, getAllComList_failure,

	updateExpiryDate_request, updateExpiryDate_success, updateExpiryDate_failure,
	updatePaymentDueDate_request, updatePaymentDueDate_success, updatePaymentDueDate_failure,
	resetPaymentDueDate_request, resetPaymentDueDate_success, resetPaymentDueDate_failure,
	updateDealerCode_request, updateDealerCode_success, updateDealerCode_failure,
	updateBillingTag_request, updateBillingTag_success, updateBillingTag_failure,
	updatePackage_request, updatePackage_success, updatePackage_failure,

	suspendCOM_request, suspendCOM_success, suspendCOM_failure,
	deleteCOM_request, deleteCOM_success, deleteCOM_failure,
	revertDeletedCOM_request, revertDeletedCOM_success, revertDeletedCOM_failure,
	activateCOM_request, activateCOM_success, activateCOM_failure,
	getPackages_request, getPackages_success, getPackages_failure,
	updateTrialStatus_request, updateTrialStatus_success, updateTrialStatus_failure,
	setSuspendDate_request, setSuspendDate_success, setSuspendDate_failure,
	removeSuspendDate_request, removeSuspendDate_success, removeSuspendDate_failure,
} = accountControlSlice.actions;

export default accountControlSlice.reducer;